import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerAppServiceWorker } from './shared/pwa.js';
import { installStaleVersionGuard } from './shared/stale-version.js';
import { queryClient, router } from './shared/router.js';
import './shared/styles.css';

async function start() {
  // Après un déploiement, un onglet resté ouvert recharge une fois au lieu d'échouer.
  installStaleVersionGuard();
  // Maquettes MSW : développement uniquement, sur demande explicite.
  const mocks = import.meta.env.DEV && import.meta.env.VITE_USE_MOCKS === 'true';
  // Vague 5 : service worker de l’application (push, aucune mise en cache), en production seulement :
  // jamais avec les maquettes MSW (même portée `/`), ni en développement.
  if (import.meta.env.PROD && !mocks) void registerAppServiceWorker();
  if (mocks) {
    // Si les maquettes ne démarrent pas (service worker refusé), l'application s'affiche quand même.
    try {
      const { worker } = await import('./mocks/browser.js');
      await worker.start();
    } catch (err) {
      console.warn('Maquettes MSW indisponibles :', err);
    }
  }
  const el = document.getElementById('root');
  if (!el) throw new Error('#root manquant');
  createRoot(el).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </StrictMode>,
  );
}

void start();
